import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ProjectionProgressView } from '../../types';

@Component({
  selector: 'ts-ai-analysis-in-progress-banner',
  templateUrl: './ai-analysis-in-progress-banner.component.html',
  styleUrls: ['./ai-analysis-in-progress-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AiAnalysisInProgressBannerComponent {
  @Input() public visible = false;
  @Input() public compact = false;
  /** When set, renders this i18n key instead of the AI in-progress messages. */
  @Input() public messageKey?: string;
  @Input() public showRefresh = false;
  @Input() public attention = false;
  @Input() public pollingExhausted = false;
  @Input() public error = false;
  /** When set, renders a determinate bar; callers with nothing to count omit it. */
  @Input() public progress?: ProjectionProgressView;

  public get displayMessageKey(): string {
    if (this.messageKey) {
      return this.messageKey;
    }

    if (this.error) {
      return 'info.micro_ai_analysis_error';
    }

    return this.pollingExhausted ? 'info.micro_ai_analysis_polling_exhausted' : 'info.micro_ai_analysis_in_progress';
  }

  public get showRefreshButton(): boolean {
    return !this.error && (this.showRefresh || this.pollingExhausted);
  }

  public get attentionStyle(): boolean {
    return !this.error && (this.attention || this.pollingExhausted);
  }

  public refresh(): void {
    window.location.reload();
  }
}
